import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { DashboardColumnCount } from '../config/dashboardWidgets';
import { COLORS } from '../constants/theme';

interface DashboardColumnCountSelectorProps {
  readonly columnCount: DashboardColumnCount;
  readonly onChange: (columnCount: DashboardColumnCount) => void;
  readonly isMobileViewport: boolean;
}

export const DashboardColumnCountSelector: React.FC<DashboardColumnCountSelectorProps> = ({
  columnCount,
  onChange,
  isMobileViewport,
}) => (
  <View>
    <Text style={styles.title}>Columns</Text>
    <Text style={styles.subtitle}>
      {isMobileViewport
        ? 'Mobile always uses 1 column. This setting applies on tablet and desktop.'
        : 'Maximum 2 columns. 1 column shows every widget at full width.'}
    </Text>
    <View style={styles.group} accessibilityRole="tablist">
      <TouchableOpacity
        style={[styles.option, columnCount === 1 && styles.optionActive]}
        onPress={() => onChange(1)}
        activeOpacity={0.7}
        accessibilityRole="tab"
        accessibilityState={{ selected: columnCount === 1 }}
        accessibilityLabel="1 column"
      >
        <Text style={[styles.optionText, columnCount === 1 && styles.optionTextActive]}>1</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.option, columnCount === 2 && styles.optionActive]}
        onPress={() => onChange(2)}
        activeOpacity={0.7}
        accessibilityRole="tab"
        accessibilityState={{ selected: columnCount === 2 }}
        accessibilityLabel="2 columns"
      >
        <Text style={[styles.optionText, columnCount === 2 && styles.optionTextActive]}>2</Text>
      </TouchableOpacity>
    </View>
  </View>
);

const styles = StyleSheet.create({
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: '#222',
    marginBottom: 4,
    fontFamily: 'Montserrat_700Bold',
  },
  subtitle: {
    fontSize: 13,
    color: COLORS.textSecondary,
    marginBottom: 12,
    fontFamily: 'Montserrat_400Regular',
  },
  group: {
    flexDirection: 'row',
    alignSelf: 'flex-start',
    borderWidth: 1,
    borderColor: '#E5E7EB',
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 16,
  },
  option: {
    minWidth: 44,
    minHeight: 44,
    paddingHorizontal: 18,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.white,
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  optionActive: {
    backgroundColor: 'rgba(0,80,110,0.10)',
  },
  optionText: {
    fontSize: 16,
    fontWeight: '700',
    color: '#9CA3AF',
    fontFamily: 'Montserrat_700Bold',
  },
  optionTextActive: {
    color: COLORS.primary,
  },
});
